import axios from 'axios';
// Create axios instance with baseURL
const instance = axios.create({
  baseURL: process.env.REACT_APP_PROXY
});

// Add a response interceptor
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Dispatch logout action which will handle clearing localStorage
      console.log('401 error');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userProfile');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;
